import { render, staticRenderFns } from "./Reception.vue?vue&type=template&id=0d4947c3&"
import script from "./Reception.vue?vue&type=script&lang=js&"
export * from "./Reception.vue?vue&type=script&lang=js&"
import style0 from "./Reception.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports